export default __webpack_public_path__ + "static/media/cart.1c43f629.svg";